import { PLAN_NAMES, PLAN_ROWS } from '@/data/planTable';

/** 지원 여부는 점/하이픈으로 그리고, 스크린리더에는 말로 읽힌다 */
function Cell({ value }) {
  if (value === true) {
    return (
      <td>
        <span className="plan-dot" aria-hidden="true" />
        <span className="sr-only">지원</span>
      </td>
    );
  }
  if (value === false) {
    return (
      <td>
        <span aria-hidden="true">-</span>
        <span className="sr-only">미지원</span>
      </td>
    );
  }
  return <td>{value}</td>;
}

export function PlanTable() {
  return (
    <div className="relative overflow-x-auto rounded-t-2xl">
      <table className="plan-table min-w-[880px]">
        <caption className="sr-only">Nova 온프레미스 구축형 플랜별 기능 비교표</caption>
        <thead>
          <tr>
            <th scope="col" className="w-[200px]">
              <span className="sr-only">항목</span>
            </th>
            {PLAN_NAMES.map((name) => (
              <th key={name} scope="col">
                {name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {PLAN_ROWS.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              {row.cells.map((value, index) => (
                <Cell key={PLAN_NAMES[index]} value={value} />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
